import { AppError } from "./appError.js";
export class InvalidDossierId extends AppError {
    status = 400;
    message = "Invalid dossier ID.";
    code = "version/invalid-dossier-id";
}
export class DossierIdNotProvided extends AppError {
    status = 400;
    message = "Dossier ID was not provided.";
    code = "version/dossier-id-not-provided";
}
export class VersionCreationNotAllowed extends AppError {
    status = 403;
    message = "User is not allowed to create a new version.";
    code = "version/creation-not-allowed";
}
export class VersionNotFound extends AppError {
    status = 404;
    message = "Version was not found.";
    code = "version/not-found";
}
export class VersionCountLimit extends AppError {
    status = 409;
    message = "This dossier can't have any more versions.";
    code = "version/count-limit";
}
export class FinancingIncompleteMissingLender extends AppError {
    status = 400;
    message = "Financing incomplete";
    code = "financing/missing-lender";
}
export class ProvideDossierVersionId extends AppError {
    status = 400;
    message = "Please provide a dossier ID and a version ID";
    code = "version/provide-dossier-version-id";
}
export class EditNotAllowed extends AppError {
    status = 403;
    message = "User can't edit this version.";
    code = "version/edit-not-allowed";
}
export class VersionDataNotSpecified extends AppError {
    status = 400;
    message = "The parameter versionData was not provided.";
    code = "version/provide-versiondata";
}
export class VersionIdNotSpecified extends AppError {
    status = 400;
    message = "Please provide a version ID.";
    code = "version/id-not-provided";
}
export class InvalidDossierVersionId extends AppError {
    status = 400;
    message = "An invalid dossier ID or version ID was provided.";
    code = "version/invalid-dossier-version-id";
}
export class NoNotesFoundError extends AppError {
    status = 404;
    message = "No notes were found for this dossier version";
    code = "version/no-notes-found";
}
